import React, { ComponentProps } from "react";
import { BorderRectProps } from "./dto";

const BorderRect = ({
  x,
  y,
  width,
  height,
  visible,
  color,
  bg,
}: BorderRectProps) => {
  if (!visible) {
    return null;
  }
  return (
    <>
      {bg && (
        <div
          style={{
            transform: `translate(${x}px, ${y}px)`,
            width: width,
            height: height,
            backgroundColor: bg,
            transformOrigin: "0 0",
          }}
          className="wbuc-absolute"
        ></div>
      )}
      {color && color !== "transparent" && (
        <>
          <div
            style={{
              transform: `translate(${x}px, ${y}px)`,
              width: width + 1,
              height: 2,
              backgroundColor: color,
              transformOrigin: "0 0",
            }}
            className="wbuc-absolute"
          ></div>
          <div
            style={{
              transform: `translate(${x}px, ${y + height}px)`,
              width: width - 4,
              height: 2,
              backgroundColor: color,
              transformOrigin: "0 0",
            }}
            className="wbuc-absolute"
          ></div>
          <div
            style={{
              transform: `translate(${x}px, ${y}px)`,
              width: 2,
              height: height,
              backgroundColor: color,
              transformOrigin: "0 0",
            }}
            className="wbuc-absolute"
          ></div>
          <div
            style={{
              transform: `translate(${x + width}px, ${y}px)`,
              width: 2,
              height: height - 4,
              backgroundColor: color,
              transformOrigin: "0 0",
            }}
            className="wbuc-absolute"
          ></div>
          <div
            style={{
              transform: `translate(${x + width - 3}px, ${y + height - 3}px)`,
              width: 6,
              height: 6,
              backgroundColor: color,
              transformOrigin: "0 0",
            }}
            className="wbuc-absolute wbuc-rounded-full"
          ></div>
        </>
      )}
    </>
  );
};

const Container = ({ children, ...rest }: ComponentProps<"div">) => (
  <div
    {...rest}
    className="wbuc-pointer-events-none wbuc-absolute wbuc-inset-0 wbuc-size-full"
  >
    {children}
  </div>
);

BorderRect.Container = Container;

export default BorderRect;
